import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "quotewizard" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "quoteleft" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Personal Property Add-On", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "poweredby" }, "Provided by NSSI", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "addpp",
  class: "subtitle",
  style: {"color":"#414142"}
}, " Add Accidental Damage Coverage ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "policyoptionstable"
}
const _hoisted_15 = { width: "30%" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("strong", { class: "subsubtitle" }, "Coverage", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_18 = { align: "right" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Please Select...", -1)
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "policyoptionstable"
}
const _hoisted_23 = { width: "30%" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("strong", { class: "subsubtitle" }, "Deductible", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_26 = { align: "right" }
const _hoisted_27 = ["id", "value"]
const _hoisted_28 = ["for"]
const _hoisted_29 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "policyoptionstable"
}
const _hoisted_30 = { width: "30%" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("strong", { class: "subsubtitle" }, "Payment Options", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_33 = { align: "right" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1)
const _hoisted_37 = { style: {"text-align":"center"} }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import QuoteCart from "@/views/quote/QuoteCart.vue";
import HelpPopup from "@/components/HelpPopup.vue";
import { scrollMeTo, stat } from "@/utils/Utils";
import { NssiData } from "@/api/NssiData";
import { PaymentOptions } from "@/models/QuoteInsurance";
import Loader from "@/components/MainLoader.vue";
import StatusComponent from "@/components/StatusComponent.vue";
import ValidationError from "@/components/ValidationError.vue";
import ProductService from "@/services/ProductService";
import { inject, onMounted, ref, computed, Ref, ComputedRef } from "vue";
import { useQuoteStore } from "@/stores/root/quote";
import { useStatusStore } from "@/stores/root/status";

const title = "Add-On";

export default /*#__PURE__*/_defineComponent({
  __name: 'QuoteAddon',
  props: {
  anchor: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;


const quote = useQuoteStore();
const loading: Ref<boolean> = ref(false);
const validationErrors: Ref<any[]> = ref([]);
const nssiCoverages: Ref<any[]> = ref([]);
const statusStore = useStatusStore();
const inj = inject("$emitter");

const getCoverages = async () => {
  try {
    const products = await ProductService.all();
    nssiCoverages.value.push(products[0].coverage_amount);
  } catch (error) {
    throw "Products load error";
  }
};

onMounted(() => {
  getCoverages();
});

const validated = computed(() => {
  const personalValidate =
    quote.personalInsurance.coverageAmount > 0 &&
    quote.personalInsurance.deductibleAmount &&
    quote.personalInsurance.paymentOption;

  return quote.hasPersonalInsurance ? personalValidate : true;
});

function createValidationMessages(): void {
  validationErrors.value.length = 0;

  if (!(quote.personalInsurance.coverageAmount > 0)) {
    const error = {
      name: "coverageAmount",
      value: "Coverage is required.",
    };
    validationErrors.value.push(error);
  }

  if (!(quote.personalInsurance.deductibleAmount > 0)) {
    const error = {
      name: "personalDeductible",
      value: "Deductible is required.",
    };
    validationErrors.value.push(error);
  }

  if (!(quote.personalInsurance.paymentOption > 0)) {
    const error = {
      name: "personalLiabilityPaymentPlan",
      value: "Payment option is required.",
    };
    validationErrors.value.push(error);
  }
}

function goToPage(command: string) {
  if (!validated.value) {
    createValidationMessages();
    stat(statusStore).error("Please fill in required fields.");
    scrollMeTo("status");
    return;
  }
  quote.setQuoteStep(command);
}

const readNssiRates = async () => {
  const ratesResult = await NssiData.getRates(quote);
  if (ratesResult.error) {
    stat(statusStore).error(ratesResult.message);
    scrollMeTo("status");
  } else {
    if (ratesResult.result.Rates && ratesResult.result.Rates[0]) {
      const rate = ratesResult.result.Rates[0];
      quote.personalInsurance.annualAmount = rate.AnnualPremium;
      quote.personalInsurance.monthlyAmount = rate.InstallmentPayment;
      quote.personalInsurance.installmentAmount = rate.InstallmentPremium;
      quote.personalInsurance.sku = rate.SKU;
      quote.personalInsurance.processingFeeSku =
        quote.personalInsurance.paymentOption == PaymentOptions.Monthly
          ? rate.ProcessingFeeSKU_Installment
          : rate.ProcessingFeeSKU;
      quote.personalInsurance.dueToday =
        quote.personalInsurance.paymentOption == PaymentOptions.Monthly
          ? quote.personalInsurance.monthlyAmount
          : quote.personalInsurance.annualAmount;
      quote.personalInsurance.retailPremium =
        quote.personalInsurance.paymentOption == PaymentOptions.Monthly
          ? rate.InstallmentPayment
          : rate.AnnualPremium;
    }
  }
};

function clearValidationMessage(name: string): void {
  const elements = validationErrors.value.filter((element) => {
    return element.name == name;
  });
  elements.forEach((element) => {
    const index = validationErrors.value.indexOf(element);
    validationErrors.value.splice(index, 1);
  });
  if (!validationErrors.value.length) {
    stat(statusStore).clear();
  }
}

function validatedFieldChanged(event: any): void {
  if (!event || !event.target || !event.target.name) {
    return;
  }
  clearValidationMessage(event.target.name);
}

const quoteChange = async (event: any) => {
  (inj as any).emit("quote-changed");
  validatedFieldChanged(event);
};

const nssiQuoteChange = async (event: any) => {
  if (
    quote.hasPersonalInsurance &&
    quote.personalInsurance.coverageAmount &&
    quote.personalInsurance.deductibleAmount
  ) {
    loading.value = true;
    stat(statusStore).clear();
    await readNssiRates();
    loading.value = false;
    quote.showAddonOnCart = true;
  }
  quoteChange(event);
};

const nssiDeductibles: ComputedRef<any> = computed(() => {
  return NssiData.deductibles;
});

function hasErrors(name: string): boolean {
  return (
    validationErrors.value.find((element) => {
      return element.name == name;
    }) != null
  );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(Loader, { loading: loading.value }, null, 8, ["loading"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _createVNode(StatusComponent),
        _withDirectives(_createElementVNode("input", {
          id: "addpp",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(quote).hasPersonalInsurance) = $event)),
          type: "checkbox",
          class: "styledchecked",
          name: "liability-ded",
          "true-value": true,
          onChange: nssiQuoteChange
        }, null, 544), [
          [_vModelCheckbox, _unref(quote).hasPersonalInsurance]
        ]),
        _hoisted_9,
        _createVNode(HelpPopup, { msg: "Covers your phone, laptop, camera, headphones --- from accidental drops, cracked screens or liquid damage." }),
        _hoisted_10,
        _hoisted_11,
        _hoisted_12,
        (_unref(quote).hasPersonalInsurance)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("table", _hoisted_14, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_15, [
                      _hoisted_16,
                      _hoisted_17,
                      _createVNode(HelpPopup, {
                        msg: "The maximum payout per claim.",
                        "help-class": "help smallhelp"
                      })
                    ]),
                    _createElementVNode("td", _hoisted_18, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(quote).personalInsurance.coverageAmount) = $event)),
                        style: {"width":"60%"},
                        name: "coverageAmount",
                        class: _normalizeClass({ validationfield: hasErrors('coverageAmount') }),
                        disabled: !nssiCoverages.value[0],
                        onChange: nssiQuoteChange
                      }, [
                        _hoisted_20,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nssiCoverages.value[0], (coverage) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: coverage.value,
                            value: coverage.value
                          }, _toDisplayString(coverage.text), 9, _hoisted_21))
                        }), 128))
                      ], 42, _hoisted_19), [
                        [_vModelSelect, _unref(quote).personalInsurance.coverageAmount]
                      ]),
                      _createVNode(ValidationError, {
                        name: "coverageAmount",
                        errors: validationErrors.value
                      }, null, 8, ["errors"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("table", _hoisted_22, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_23, [
                      _hoisted_24,
                      _hoisted_25,
                      _createVNode(HelpPopup, {
                        msg: "A deductible is the amount the policyholder must pay before the insurer pays out\n                                            the claim.",
                        "help-class": "help smallhelp"
                      })
                    ]),
                    _createElementVNode("td", _hoisted_26, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nssiDeductibles.value, (deductible) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          _withDirectives(_createElementVNode("input", {
                            id: 'pp-ded-' + deductible.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(quote).personalInsurance.deductibleAmount) = $event)),
                            type: "radio",
                            class: "styledradio",
                            name: "personalDeductible",
                            value: deductible.value,
                            onChange: nssiQuoteChange
                          }, null, 40, _hoisted_27), [
                            [_vModelRadio, _unref(quote).personalInsurance.deductibleAmount]
                          ]),
                          _createElementVNode("label", {
                            name: "personalDeductible",
                            for: 'pp-ded-' + deductible.value,
                            class: _normalizeClass({
                        validationfield: hasErrors('personalDeductible'),
                      }),
                            style: {"margin-left":"5px !important"},
                            onClick: validatedFieldChanged
                          }, _toDisplayString(deductible.text), 11, _hoisted_28)
                        ], 64))
                      }), 256)),
                      _createVNode(ValidationError, {
                        name: "personalDeductible",
                        errors: validationErrors.value
                      }, null, 8, ["errors"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("table", _hoisted_29, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_30, [
                      _hoisted_31,
                      _hoisted_32,
                      _createVNode(HelpPopup, {
                        msg: "Choose a payment plan that's best for you: monthly or annual.",
                        "help-class": "help smallhelp"
                      })
                    ]),
                    _createElementVNode("td", _hoisted_33, [
                      _withDirectives(_createElementVNode("input", {
                        id: "pp-paymentplan-monthly",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(quote).personalInsurance.paymentOption) = $event)),
                        type: "radio",
                        class: "styledradio",
                        name: "personalLiabilityPaymentPlan",
                        value: 1,
                        onChange: nssiQuoteChange
                      }, null, 544), [
                        [
                          _vModelRadio,
                          _unref(quote).personalInsurance.paymentOption,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      _createElementVNode("label", {
                        name: "personalLiabilityPaymentPlan",
                        for: "pp-paymentplan-monthly",
                        class: _normalizeClass({
                      validationfield: hasErrors(
                        'personalLiabilityPaymentPlan'
                      ),
                    }),
                        style: {"margin-left":"5px !important"},
                        onClick: validatedFieldChanged
                      }, " Monthly ", 2),
                      _withDirectives(_createElementVNode("input", {
                        id: "pp-paymentplan-annual",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(quote).personalInsurance.paymentOption) = $event)),
                        type: "radio",
                        class: "styledradio",
                        name: "personalLiabilityPaymentPlan",
                        value: 2,
                        onChange: nssiQuoteChange
                      }, null, 544), [
                        [
                          _vModelRadio,
                          _unref(quote).personalInsurance.paymentOption,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      _createElementVNode("label", {
                        name: "personalLiabilityPaymentPlan",
                        for: "pp-paymentplan-annual",
                        class: _normalizeClass({
                      validationfield: hasErrors(
                        'personalLiabilityPaymentPlan'
                      ),
                    }),
                        style: {"margin-left":"5px !important"},
                        onClick: validatedFieldChanged
                      }, " Annual ", 2),
                      _createVNode(ValidationError, {
                        name: "personalLiabilityPaymentPlan",
                        errors: validationErrors.value
                      }, null, 8, ["errors"])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_34,
        _hoisted_35,
        _hoisted_36,
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("button", {
            class: _normalizeClass({ disabled: !validated.value }),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (goToPage('quote-account')))
          }, " Continue ", 2)
        ]),
        _hoisted_38,
        _hoisted_39,
        _hoisted_40,
        _hoisted_41,
        _hoisted_42,
        _hoisted_43
      ]),
      _createVNode(QuoteCart)
    ])
  ]))
}
}

})